// @docs https://[domain]/api/v1/docs
export default {
  List: "/users",
  Detail: "/users",
  Create: "/users",
  Update: "/users",
  SetPassword: "/users",
};
